import React from "react";
import { ButtonRenderProps, ContentSection } from "sprint-common-web";

import { FileRecordBuzzView } from "../../../../../common/file-record-details/buzz/FileRecordBuzzView";
import { useFileRecordDetailsState } from "../../../hooks/useFileRecordDetailsState";
import { ApproveFileRecordDetailsNotificationsButton } from "./approve-notifications/ApproveFileRecordDetailsNotificationsButton";

export const FileRecordBuzzSection = (): JSX.Element => {
    const { isLoading, fileRecordDetails } = useFileRecordDetailsState();

    const fileRecordEditButton: ButtonRenderProps = {
        render: ApproveFileRecordDetailsNotificationsButton
    };

    const buttons = [fileRecordEditButton];

    return (
        <ContentSection
            header="Buzz"
            testId="buzz-content-section"
            buttons={buttons}
            isLoading={isLoading}
            style={{ height: 300 }}
        >
            <FileRecordBuzzView fileRecordDetails={fileRecordDetails} />
        </ContentSection>
    );
};
